import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Card, Col, message, Row, Spin, Table, Upload, Button } from "antd";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined,
} from "@ant-design/icons";
class DashboardPage extends Component {
  constructor() {
    super();

    this.state = {
      statistics: {},
      exelFile: false
    };
  }

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    if (this.props.permissions.view) {
      API.dashboard
        .list()
        .then((result) => {
          this.setState({ loaded: true, statistics: result.data });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
  }

  handleUploadFile = async () => {
    this.setState({ uploadLoading: true });
    const formData = new FormData();
    formData.append("file", this.state.exelFile);
    try {
      const data = await API.product.excelUpload(formData);
      console.log(data);
    } catch (error) {
      console.log("Error :");
      console.log(error);
      this.setState({ uploadLoading: false });
      if (error.status === true) {
        message.success(`فایل ${this.state.exelFile.name} با موفقیت آپلود شد.`);
        this.setState({ exelFile: null });
      } else {
        message.error("فایل آپلود نشد. دقت شود فایل از نوع اکسل باشد");
      }
    }
  };
  render() {
    const { loaded, exelFile } = this.state;
    const { permissions } = this.props;

    const Uploader = () => {
      const props = {
        beforeUpload: (file) => {
          this.setState({
            exelFile: file,
          });
        },
        onChange: (info) => {
          console.log(info.fileList);
        },
      };
      return (
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>آپلود فایل</Button>
        </Upload>
      );
    };

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.dashboard}</Breadcrumb.Item>
        </Breadcrumb>
    
       


        {/* {loaded && (
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.dailyPosition}
                  description={statistics.dailyPosition || "0"}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.sellingPrices}
                  description={PriceFormat(statistics.sellingPrices)}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={Resources.usersNow}
                  description={statistics.usersNow}
                />
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                    title={Resources.installedAppsCount}
                    description={statistics.installedApp}
                />
              </Card>
            </Col>
            <Col xs={24}>
              <Card bordered={false} style={{ marginBottom: 16 }}>
                <Card.Meta
                  title={`${Resources.maximumShop} (${Resources.month})`}
                  style={{ marginBottom: 16 }}
                />
                {!!Object.keys(statistics.maximumShop).length && (
                  <Table
                    columns={userColumns}
                    dataSource={statistics.maximumShop}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    scroll={{ x: 600 }}
                  />
                )}
              </Card>
            </Col>
            <Col xs={24}>
              <Card bordered={false}>
                <Card.Meta
                  title={`${Resources.maximumShopProduct} (${Resources.month})`}
                  style={{ marginBottom: 16 }}
                />
                <Table
                  columns={productColumns}
                  dataSource={statistics.maximumShopProduct}
                  pagination={false}
                  size="small"
                  rowKey="id"
                  scroll={{ x: 600 }}
                />
              </Card>
            </Col>
          </Row>
        )} */}
        {!loaded && permissions.view && <Spin className="ant-spin-center" />}
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        view: CheckPermission(state.app.user, Permissions.dashboard_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(DashboardPage);
